export default {
  buttonLabel: 'Mudar apontamento',
  closeLabel: 'Fechar',
  icon: '$localization-globe-outline',
  title: 'Mudar o apontamento de um domínio para a Locaweb',
  subtitle: `Mudar o apontamento não implica na transferência do domínio para a Locaweb.
            <br/>Siga os passos abaixo para realizar o apontamento:`,
  listItems: {
    knowHow: '1. No provedor onde registrou o domínio, entre nas configurações de apontamento da Zona DNS',
    helpTable: '2. Nessas configurações, informe os seguintes dados:',
    spread: '3. Aguarde o tempo de propagação'
  },
  knowHow: 'Saiba como',
  helpTable: {
    headers: {
      entry: 'Entrada',
      type: 'Tipo',
      priority: 'Prio',
      content: 'Conteúdo'
    },
    items: [
      {
        entry: '',
        type: 'A',
        priority: '0',
        content: '186.202.135.240'
      },
      {
        entry: 'www',
        type: 'CNAME',
        priority: '0',
        content: 'seudominio.com.br'
      }
    ]
  },
  propagationInfo: [
    'Este é o tempo que o seu domínio leva para ficar online em todo o mundo.',
    'Pode variar de 30 minutos a 48 horas.',
    'Após este período, seu domínio estará pronto para ser utilizado no Criador de Sites.'
  ]
}
